import React from 'react';
import { useThree} from '@react-three/fiber';
import { Model } from './3DModel';
import { useMediaQuery } from 'react-responsive';

function Objects() {
    const { height, width } = useThree((state) => state.viewport);
    const isCentered = useMediaQuery({
        query: '(min-width: 964px)'
    })
    const isMobile = useMediaQuery({
        query: '(max-width: 600px) AND (max-height: 930px)'
    })

    return (
        <>
            <spotLight position={[5, 0, 5]} intensity={2.5} penumbra={1} angle={0.35} castShadow color="#0c8cbf" />
            <directionalLight position={[width / 6, -height * 1, 0]} intensity={1} color="red" />
            <Model model="JSLogo" position={isCentered ? [0 - width / 5, 0, 0] : [0, 0, 0]} scale={1.5} />
            {/* Block 1 */}
            <Model model="HTML5" lazy position={isMobile ? [-width / 4,  -height * 0.7, 0] : [-width / 3, -height * 0.8, 0]} scale={2.3} />
            <Model model="CSS3" lazy position={isMobile ? [width / 4 - 0.05, -height * 0.755, 0] : [0 - 0.05, -height * 0.85, 0]} scale={2.2} />
            <Model model="Figma" lazy position={isMobile ? [-width / 4, -height * 0.905, 0] : [width / 3, -height * 0.8, 0]} scale={1.15} />
            <Model model="JavaScript" lazy position={isMobile ? [width / 4, -height * 0.89, 0] : [-width / 3, -height * 1.02, 0]} scale={0.8} />
            <Model model="ReactLogo" lazy position={isMobile ? [-width / 4, -height * 1.1, 0] : [0, -height * 1.02, 0]} scale={1} />
            <Model model="ThreeJS" lazy position={isMobile ? [width / 4, -height * 1.1, 0] : [width / 3, -height * 1.01, 0]} scale={0.6} />
            {/* Block 2 */}
            <Model model="Postgres" lazy position={isMobile ? [-width / 4,  -height * 1.4, 0] : [-width / 3, -height * 1.4, 0]} scale={1} />
            <Model model="Linux" lazy position={isMobile ? [width / 4,  -height * 1.4, 0] : [0, -height * 1.4, 0]} scale={1} />
            <Model model="AWS" lazy position={isMobile ? [-width / 4,  -height * 1.6, 0] : [width / 3, -height * 1.4, 0]} scale={0.8} />
            <Model model="API" lazy position={isMobile ? [width / 4,  -height * 1.6, 0] : [-width / 3.1, -height * 1.63, 0]} scale={0.8} />
            <Model model="Git" lazy position={isMobile ? [-width / 4,  -height * 1.8, 0] : [0, -height * 1.63, 0]} scale={0.9} />
            <Model model="NodeJS" lazy position={isMobile ? [width / 4,  -height * 1.8, 0] : [width / 3, -height * 1.62, 0]} scale={0.8} />
            {/* Block 3 */}
            <Model model="Python" lazy position={isMobile ? [-width / 4,  -height * 2.1, 0] : [-width / 3, -height * 2, 0]} scale={0.9} />
            <Model model="CPP" lazy position={isMobile ? [width / 4,  -height * 2.1, 0] : [0, -height * 2, 0]} scale={0.9} />
            <Model model="Java" lazy position={isMobile ? [-width / 4,  -height * 2.3, 0] : [width / 3, -height * 2, 0]} scale={1.15} />
        </>
    )
}    

export default Objects;